module.exports = __webpack_public_path__ + "static/moneyball-the-art-of-winning-an-unfair-game-29e916d0deeefb53b82b5b1b6a484d67.jpg";